module.exports = __webpack_public_path__ + "static/media/user_report.57ce4a1f.svg";